import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';
import { servicesProviderRegistrationDataSchema } from './ServicesProviderRegistrationData.js';

class ServicesProviderRegistration extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderRegistrationDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderRegistration.validation', `ServicesProviderRegistration data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.REGISTRATION,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.REGISTRATION, ServicesProviderRegistration);

export { ServicesProviderRegistration };
//# sourceMappingURL=ServicesProviderRegistration.js.map
